import { c as _c } from "react/compiler-runtime";
import { getCurrencyKey } from "@opensea/app-kit";
import { AnimatedNumber, ItemAvatar, ItemContent, ItemDescription, ItemSide, ItemTitle, NumberDisplay, Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Item } from "../Item";
import { CurrencyItemChainBadge } from "./CurrencyItemChainBadge";
export function CurrencyItem(t0) {
  const $ = _c(28);
  const {
    currency,
    onClick
  } = t0;
  const t = useTranslations("wallet.CurrencyItem");
  let t1;
  if ($[0] !== currency.chainIdentifier) {
    t1 = <CurrencyItemChainBadge identifier={currency.chainIdentifier} />;
    $[0] = currency.chainIdentifier;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currency) {
    t2 = getCurrencyKey(currency);
    $[2] = currency;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== currency.imageUrl || $[5] !== t1 || $[6] !== t2) {
    t3 = <ItemAvatar badge={t1} className="bg-bg-additional-1" rounded={true} seed={t2} size={42} src={currency.imageUrl} />;
    $[4] = currency.imageUrl;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== currency.name) {
    t4 = <ItemTitle>{currency.name}</ItemTitle>;
    $[8] = currency.name;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== currency.symbol) {
    t5 = <ItemDescription>{currency.symbol}</ItemDescription>;
    $[10] = currency.symbol;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <ItemContent>{t4}{t5}</ItemContent>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== currency.usdPrice) {
    t7 = <ItemTitle><NumberDisplay display="usd" value={currency.usdPrice} /></ItemTitle>;
    $[15] = currency.usdPrice;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== currency.stats || $[18] !== t) {
    t8 = currency.stats?.marketCapUsd && <Tooltip content={t("marketCap")}><ItemDescription className="font-mono"><AnimatedNumber display="usd" value={currency.stats.marketCapUsd} />{" "}{t("mc")}</ItemDescription></Tooltip>;
    $[17] = currency.stats;
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <ItemSide className="items-end">{t7}{t8}</ItemSide>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== onClick || $[24] !== t3 || $[25] !== t6 || $[26] !== t9) {
    t10 = <Item className="!rounded-lg border-0 p-2" onClick={onClick}>{t3}{t6}{t9}</Item>;
    $[23] = onClick;
    $[24] = t3;
    $[25] = t6;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}